import { render, staticRenderFns } from "./FaviconForm.vue?vue&type=template&id=48eb6e04&scoped=true"
import script from "./FaviconForm.vue?vue&type=script&lang=js"
export * from "./FaviconForm.vue?vue&type=script&lang=js"
import style0 from "./FaviconForm.vue?vue&type=style&index=0&id=48eb6e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb6e04",
  null
  
)

export default component.exports